import { createAction, props } from '@ngrx/store';

export const changeClinicalTracks = createAction('[CLINICAL TRACKS] Clinical Tracks Changed', props<{ clinicalTracksChanged: boolean }>());
